var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodolist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441.319,
    height: 510.674,
    viewBox: "0 0 441.319 510.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "matrix(0.899, -0.438, 0.438, 0.899, -422.262, 184.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M16.28,0H251.82A16.28,16.28,0,0,1,268.1,16.28V349.89a16.28,16.28,0,0,1-16.28,16.28H16.28A16.28,16.28,0,0,1,0,349.89V16.28A16.28,16.28,0,0,1,16.28,0Z",
    transform: "translate(401.402 140.257)",
    fill: "#a062b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 232.985,
    height: 318.211,
    rx: 5.624,
    transform: "translate(418.959 169.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M669.226,525.546l-238.842.238c-3.874.814-14.739-2.166-16.28-14.082l.926-334.918Z",
    transform: "translate(-12.702 -19.72)",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 151.516,
    cy: 16.16,
    rx: 151.516,
    ry: 16.16,
    transform: "translate(374.447 509.796) rotate(25)",
    fill: "#eea8c5",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(432.911 222.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M510.143,317.627H455.467V262.952h54.676Zm-52.716-1.96h50.756V264.912H457.427Z",
    transform: "translate(-455.467 -262.952)",
    fill: "#153e49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(432.911 305.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M510.143,426.012H455.467V371.336h54.676Zm-52.716-1.96h50.756V373.3H457.427Z",
    transform: "translate(-455.467 -371.336)",
    fill: "#153e49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(432.911 387.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M510.143,534.4H455.467V479.721h54.676Zm-52.716-1.961h50.756V481.682H457.427Z",
    transform: "translate(-455.467 -479.721)",
    fill: "#153e49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(516.678 227.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 112.625,
    height: 5.608,
    fill: "#eea8c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 17.236)",
    fill: "#eea8c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 34.471)",
    fill: "#eea8c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(516.678 311.587)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 112.625,
    height: 5.608,
    fill: "#e9c5d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 17.236)",
    fill: "#e9c5d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 34.471)",
    fill: "#e9c5d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(516.678 390.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 112.625,
    height: 5.608,
    fill: "#e9c5d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 17.236)",
    fill: "#e9c5d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 112.625,
    height: 5.608,
    transform: "translate(0 34.471)",
    fill: "#e9c5d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(436.855 214.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M520.164,254.144l-39,28.679-10.491-10.651-10.027,6.708,20.088,15.826,46.148-38.737Z",
    transform: "translate(-460.645 -252.652)",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(1.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M463.325,276.087l7.059-4.721,10.534,10.695,39.5-29.047,2.969.807-42.763,35.9Z",
    transform: "translate(-462.341 -252.383)",
    fill: "#ad5fb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M480.329,290.266l-18.3-14.415,8.12-5.431L480.672,281.1l39.321-28.915,4.308,1.17ZM464,275.928l16.3,12.846,41.555-34.882-1.632-.443L480.55,282.627,470,271.916Z",
    transform: "translate(-462.033 -252.185)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(440.84 307.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M525.395,375.862l-39,28.679L475.9,393.89,465.876,400.6l20.087,15.826,46.148-38.737Z",
    transform: "translate(-465.876 -374.37)",
    fill: "#ad5fb5",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(1.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M468.556,397.805l7.059-4.721,10.534,10.695,39.5-29.047,2.969.807-42.763,35.9Z",
    transform: "translate(-467.572 -374.101)",
    fill: "#ad5fb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M485.559,411.984l-18.3-14.415,8.119-5.431L485.9,402.818,525.224,373.9l4.308,1.17Zm-16.327-14.338,16.3,12.846,41.555-34.882-1.632-.443L485.78,404.345l-10.55-10.71Z",
    transform: "translate(-467.264 -373.903)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(440.84 383.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M525.395,475.719l-39,28.679L475.9,493.746l-10.027,6.708,20.087,15.826,46.148-38.737Z",
    transform: "translate(-465.876 -474.226)",
    fill: "#ad5fb5",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(1.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M468.556,497.662l7.059-4.721,10.534,10.695,39.5-29.047,2.969.807-42.763,35.9Z",
    transform: "translate(-467.572 -473.957)",
    fill: "#ad5fb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M485.559,511.84l-18.3-14.414,8.119-5.431,10.519,10.68,39.322-28.916,4.308,1.17ZM469.232,497.5l16.3,12.846,41.555-34.882-1.632-.443L485.78,504.2,475.23,493.49Z",
    transform: "translate(-467.264 -473.759)",
    fill: "#ad5fb5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(462.469 94.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M641.25,131.164H601.4v-5.693a31.46,31.46,0,0,0-31.461-31.46h-.635a31.46,31.46,0,0,0-31.46,31.46v5.693H498a3.731,3.731,0,0,0-3.731,3.73V175.1A3.731,3.731,0,0,0,498,178.83H641.25a3.731,3.731,0,0,0,3.73-3.731V134.894A3.73,3.73,0,0,0,641.25,131.164Zm-71.625-3.739a10.515,10.515,0,1,1,10.515-10.515A10.514,10.514,0,0,1,569.625,127.424Z",
    transform: "translate(-494.269 -94.011)",
    fill: "#d8669f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(0 71.978)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 150.712,
    height: 6.309,
    transform: "translate(0)",
    fill: "#db3e8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M644.292,201.716H495.1a.835.835,0,0,1-.834-.835v-1.939H644.98v2.085A.689.689,0,0,1,644.292,201.716Z",
    transform: "translate(-494.269 -190.988)",
    fill: "#db3e8c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodolist);
export default __webpack_public_path__ + "static/media/todolist.550bec52736d2c1ae65cff1494261b60.svg";
export { ForwardRef as ReactComponent };